import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { tokens } from "../components/Theme";
import { addDays, format } from "date-fns";
import dayjs from "dayjs";
const durianStages = [
  { group: "ระยะใบ", stage: "ตัดแต่ง" },
  { group: "ระยะใบ", stage: "แตกใบอ่อน" },
  { group: "ระยะใบ", stage: "หางปลา" },
  { group: "ระยะใบ", stage: "ใบเพสลาดอ่อน" },
  { group: "ระยะใบ", stage: "ใบเพสลาด" },
  { group: "ระยะใบ", stage: "ใบแก่" },
  { group: "ระยะดอก", stage: "ไข่ปลา" },
  { group: "ระยะดอก", stage: "ตาปุ" },
  { group: "ระยะดอก", stage: "เหยีดตีนหมู" },
  { group: "ระยะดอก", stage: "กระดุม" },
  { group: "ระยะดอก", stage: "หัวกำไล" },
  { group: "ระยะดอก", stage: "ดอกขาว" },
  { group: "ระยะผล", stage: "ดอกบาน" },
  { group: "ระยะผล", stage: "หางแย้" },
  { group: "ระยะผล", stage: "ไข่ไก่" },
  { group: "ระยะผล", stage: "กระป๋องนม" },
  { group: "ระยะผล", stage: "ให้ผล" },
  { group: "ระยะผล", stage: "สุกแก่ทุเรียน" },
];

// ระยะห่างแต่ละช่วง (วัน)
const stageOffsets = [
  0, 30, 7, 28, 30, 28, 14, 7, 10, 15, 10, 7, 7, 10, 15, 15, 20, 30,
];

function calculateStagesFromStartDate(startDate) {
  const start = new Date(startDate);
  const result = {};
  let current = start;

  durianStages.forEach((stage, index) => {
    current = addDays(current, stageOffsets[index]);
    const key = `stg${index + 1}Date`;
    result[key] = format(current, "yyyy-MM-dd");
  });

  return result;
}

export default function DurianStageTable({ start_date }) {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [formData, setFormData] = useState({});
  useEffect(() => {
    if (start_date) {
      console.log(start_date)
      const calculated = calculateStagesFromStartDate(start_date);
      setFormData(calculated);
    }
  }, [start_date]);

  const handleChange = (key, value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
  };

  return (
    <Box p={2}>
      <Box
        width="100%"
        sx={{ backgroundColor: colors.greenAccent[300] }}
        display="flex"
        justifyContent="center"
      >
        <Typography
          p={isMobile ? 1 : 2}
          variant={isMobile ? "body" : "h6"}
          fontWeight="bold"
          color="#fff"
        >
          ช่วงทุเรียน เริ่มปลูกเมื่อ {dayjs(start_date).format("DD-MM-YYYY")}
        </Typography>
      </Box>
      <TableContainer component={Paper}>
        <Table size="big">
          <TableHead>
            <TableRow>
              <TableCell><strong>กลุ่มระยะ</strong></TableCell>
              <TableCell><strong>ระยะ</strong></TableCell>
              <TableCell><strong>เริ่มวันที่</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {durianStages.map(({ group, stage }, idx) => {
              const key = `stg${idx + 1}Date`;
              return (
                <TableRow key={key}>
                  <TableCell
                    sx={{
                      minWidth: isMobile ? "90px" : "none",
                      fontSize: isMobile ? "13px" : "none",
                    }}
                  >
                    {group}
                  </TableCell>
                  <TableCell>
                    <Typography
                      sx={{
                        fontSize: isMobile ? "13px" : "none",
                        color: group.includes("ระยะใบ")
                          ? "green"
                          : group.includes("ระยะดอก")
                            ? "orange"
                            : colors.blueAccent[300],
                      }}
                    >
                      {stage}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <TextField
                      type="date"
                      size="small"
                      fullWidth
                      value={formData[key] || ""}
                      onChange={(e) => handleChange(key, e.target.value)}
                      sx={{ maxWidth: isMobile ? "120px" : "300px" }}
                      InputProps={{
                        sx: {
                          "& input": {
                            fontSize: isMobile ? "12px" : "14px",
                          },
                        },
                      }}
                    />
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
